import React from 'react';
import {TextButton, TextButtonPriority} from '@wix/wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../Widget/ControllerContext';
import {classes} from './Header.st.css';
import {HeaderDataHooks} from './Header';

export const ContinueShoppingButton: React.FC = () => {
  const {
    checkoutSettingsStore,
    navigationStore: {continueShoppingUrl, clickOnContinueShopping, isContinueShoppingEnabled},
  } = useControllerProps();
  const localKeys = useLocaleKeys();

  const continueShoppingText =
    checkoutSettingsStore?.checkoutContent?.continueShoppingLink ?? localKeys.checkout.continue_shopping();

  if (!isContinueShoppingEnabled) {
    return null;
  }

  return (
    <TextButton
      as={'a'}
      className={classes.continueShoppingButton}
      data-hook={HeaderDataHooks.ContinueShoppingButton}
      href={continueShoppingUrl}
      onClick={() => clickOnContinueShopping?.()}
      priority={TextButtonPriority.link}>
      {continueShoppingText}
    </TextButton>
  );
};
